import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClientModule } from '@angular/common/http';
import { ServiceWorkerModule } from '@angular/service-worker';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getAnalytics, provideAnalytics } from '@angular/fire/analytics';
import { provideFirestore,getFirestore } from '@angular/fire/firestore';
import { providePerformance, getPerformance } from "@angular/fire/performance";

import {
  NgcCookieConsentModule,
  NgcCookieConsentConfig,
} from 'ngx-cookieconsent';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { environment } from '../environments/environment';
import { CoreModule } from './core/core.module';
import { AnalyticsService } from './core/services/analytics.service';
import { AnalyticsMockService } from './core/testing/services/analytics-mock.service';

const cookieConfig: NgcCookieConsentConfig = {
  cookie: {
    domain: environment?.domain,
  },
  palette: {
    popup: {
      background: '#030619',
    },
    button: {
      background: '#3f51b5',
    },
  },
  theme: 'edgeless',
  type: 'opt-out',
};

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    HttpClientModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.production,
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000',
    }),
    CoreModule,
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideAnalytics(() => getAnalytics()),
    provideFirestore(() => getFirestore()),
    providePerformance(() => getPerformance()),
    NgcCookieConsentModule.forRoot(cookieConfig),
  ],
  providers: [
    {
      provide: AnalyticsService,
      useClass: environment.production
        ? AnalyticsService
        : AnalyticsMockService,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
